module.exports = __webpack_public_path__ + "img/1_of_Hearts.svg.e57cc037.png";